export const FAST_MENU_LIST_MAX_HEIGHT = 300
export const FAST_MENU_LIST_ITEM_SIZE = 30
export const FAST_MENU_LIST_ITEMS_PER_PAGE = Math.ceil(
  FAST_MENU_LIST_MAX_HEIGHT / FAST_MENU_LIST_ITEM_SIZE
)
